import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";

export const GoogleChatShape = {
  webhook_url: Yup.string().label("Webhook URL").url().required(),
};

export interface GoogleChatInput {
  webhook_url: string;
}

yupResolver<GoogleChatInput>(Yup.object().shape(GoogleChatShape));
